import React, { Component } from 'react';

const BrowserConfig = () => {
  return <div></div>;
};
export default BrowserConfig;
